export const DashboardLinks = {
  dashboard: '/dashboard',
  companyAdmin: '/company-admin',
  shoppingLists: '/purchase-lists',
  addresses: '/addresses',
  quotes: '/quotes',
  orders: '/orders',
  settings: '/settings',
  approvalRules: '/approval-rules',
  approvalFlows: '/approval-flows',
  // EWM-561 — detail lives under the same `/purchase-lists` base as the header
  // route, so the module sits behind one consistent URL prefix.
  shoppingListDetail: (id: string) => `/purchase-lists/${id.replace(/\s+/g, '-')}`,
  quoteDetail: (id: string) => `/quote/${id.replace(/\s+/g, '-')}`,
  quoteRequestDetail: (id: string) => `/quote-request/${id.replace(/\s+/g, '-')}`,
  orderDetail: (id: string) => `/orders?orderId=${encodeURIComponent(id)}`,
  approvalRuleDetail: (id: string) => `/approval-rule/${id.replace(/\s+/g, '-')}`,
  approvalFlowDetail: (id: string) => `/approval-flow/${id.replace(/\s+/g, '-')}`,
};
